export default __webpack_public_path__ + "static/media/logout.6faf02b9.svg";